export default {
  container: {
    paddingBottom: '20px',
  },
  line: {
    display: 'inline-block',
    margin: '20px 20px 0px 20px'
  },
  label: {
    display: 'inline-block',
    minWidth: '150px',
    textAlign: 'right'
  },
  buttons: {
    padding: '25px 30px'
  },
  button: {
    margin: '0 10px'
  },
  after: {
    margin: '0 6px'
  }
};



// WEBPACK FOOTER //
// ./src/Parts/SearchPart/style.js